// extracted by mini-css-extract-plugin
module.exports = {"paper":"Paper_paper__eCA8o"};